import {Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import API_URL from "../../functions/config";

const Employees = () => {

    const [employees, setEmployees] = useState([]);
    const auth = localStorage.getItem('user');
    useEffect(() => {
        getEmployees();
    }, [])

    const getEmployees = async () => {
       
        let result = await fetch(`${API_URL}/employees/${JSON.parse(auth)._id}`, {
            headers: {
                authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
            }
        });
        result = await result.json();
        setEmployees(result);
    }


    // Delete Function
     const deleteEmployee = async (id) => {

        let response = await fetch(`${API_URL}/employee/${id}`, {
            method: "DELETE",
            headers: {
                authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
            }

        });

        let result = await response.json();

        if (result) {
            alert("Record is Deleted");
            getEmployees();
        }
    };


    // Search Function

    const searchHandle = async (event) => {
        let key = event.target.value;
        if (key) {
            let result = await fetch(`${API_URL}/searchemployees/${key}`, {
                headers: {
                    authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
                }
            });
            result = await result.json();
            if (result) {
                setEmployees(result);
            }
        } else {
            getEmployees();
        }
    }

     const formatWorkingTime = (totalSeconds) => {

        totalSeconds = Number(totalSeconds) || 0;

        const hours = Math.floor(totalSeconds / 3600);

        const minutes = Math.floor(
            (totalSeconds % 3600) / 60
        );

        const seconds = totalSeconds % 60;

        return (
            `${String(hours).padStart(2, "0")}:` +
            `${String(minutes).padStart(2, "0")}:` +
            `${String(seconds).padStart(2, "0")}`
        );
    };

       

    return (
        <div className="content">

            <main className="page-content p-4">

                <div className="card shadow-sm mb-4">

                    <div className="card-body">

                        <h2>Employees List</h2>

                        <p className="text-muted">
                            Here Your Employees
                        </p>
                        <hr></hr>

                        <div className="row justify-content-center g-4">

                            <div className='col-lg-6'>
                                <input type='text' placeholder='Search Name or Email ID' className='searchbox' onChange={searchHandle} />
                            </div>

                            <div className="col-lg-10 overflow-x-auto">

                                <table className="table table-bordered table-striped table-hover min-w-full">
                                    <thead>
                                        <tr>
                                            <th>Sr.No.</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone No.</th>
                                            <th>Working Hours</th>
                                            <th>Report</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            employees.length > 0 ? employees.map((item, index) =>
                                                <tr key={item._id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.emailid}</td>
                                                    <td>{item.phone}</td>
                                                    <td> {formatWorkingTime(item.workingMinutes)}</td>
                                                    <td><Link className='btn btn-primary btn-sm' to={"/employee-record/" + item._id}>Report</Link></td>
                                                    <td>
                                                        <button className='btn btn-danger btn-sm' onClick={() => deleteEmployee(item._id)}><i className="fa-regular fa-trash-can"></i> Delete</button>
                                                        <Link className='btn btn-primary btn-sm' to={"/update-employee/" + item._id}>Edit</Link>
                                                    </td>
                                                </tr>

                                            )

                                                : <tr><td>No Employee Found</td></tr>


                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>



                    </div>

                </div>



            </main>

        </div>

    )
}

export default Employees;